import { Navigate } from 'react-router-dom';
import { getVsAccessToken } from '../../../utils/session';

// For public user
const PublicRoute = ({ children }) => {
    const isLogin = getVsAccessToken()

    return (
      <>
        {!isLogin ? children : <Navigate to='/venture-scout/dashboard' />}
      </>
    );
}
export default PublicRoute;